import L from 'leaflet';

export function initLogsheet() {
  let detailMap = null;
  let detailMarker = null;
  let petugasMarkers = [];
  let trackingLines = [];

  $(document).on('click', '.btn-view-logsheet', function (e) {
    e.preventDefault();
    let url = $(this).data('url-detail');
    let btn = $(this);
    let originalHtml = btn.html();

    btn.html('<span class="spinner-border spinner-border-sm"></span>').prop('disabled', true);

    $.ajax({
      url: url,
      type: 'GET',
      success: function (res) {
        if (res.status === 'success') {
          let d = res.data;
          let trackingList = res.petugas_tracking || d.petugas_tracking || [];

          const $container = $('#detail-data-custom');
          $container.empty();

          // Helper functions
          const val = (key) => {
            let v = d[key];
            return v === null || v === undefined || v === '' ? '-' : v;
          };
          const statusBadge = (status) => {
            const s = (status || 'OPEN').toUpperCase();
            const map = {
              OPEN: 'bg-warning text-dark',
              CLOSE: 'bg-success text-white',
              PROSES: 'bg-info text-white',
              SELESAI: 'bg-success text-white',
            };
            return `<span class="badge ${map[s] || 'bg-secondary'} px-2 py-1">${s}</span>`;
          };

          // Foto section
          const fotoHtml =
            d['foto_justifikasi_html'] || '<span class="text-muted small">Tidak ada foto</span>';

          // Piket petugas
          const piketNames = val('piket_petugas_names');

          // Build structured layout
          $container.append(`
            <!-- Header Info Bar -->
            <div class="col-12 mb-3">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 pb-3 border-bottom">
                <div>
                  <div class="fw-bold text-dark">${val('nama_penyulang')}</div>
                  <div class="small text-muted">${val('nama_up3')} &bull; ${val('nama_ulp')}</div>
                </div>
                <div class="d-flex align-items-center gap-2">
                  ${statusBadge(val('status'))}
                  <span class="badge bg-light text-dark border px-2 py-1">${val('tanggal')}</span>
                </div>
              </div>
            </div>

            <!-- Section: Informasi Gangguan -->
            <div class="col-12 mb-3">
              <div class="small fw-bold text-uppercase text-secondary mb-2">
                Informasi Gangguan
              </div>
              <div class="bg-light rounded-3 p-3">
                <div class="row g-2">
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Indikasi</div>
                    <div class="fw-semibold">${val('indikasi')}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Lama Padam</div>
                    <div class="fw-semibold">${val('lama_padam')} <span class="text-muted small">Jam</span></div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Zona</div>
                    <div class="fw-semibold">${val('zona')}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Titik Tiang</div>
                    <div class="fw-semibold">${val('titik_tiang')}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section: Klasifikasi Padam -->
            <div class="col-12 mb-3">
              <div class="small fw-bold text-uppercase text-secondary mb-2">
                Klasifikasi Padam
              </div>
              <div class="bg-light rounded-3 p-3">
                <div class="row g-2">
                  <div class="col-md-6">
                    <div class="text-muted small">Kelompok Padam</div>
                    <div class="fw-semibold">${val('kelompok_padam')}</div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-muted small">Sub Kelompok Padam</div>
                    <div class="fw-semibold">${val('sub_kelompok_padam')}</div>
                  </div>
                  <div class="col-md-6 mt-2">
                    <div class="text-muted small">Kelompok Padam Event</div>
                    <div class="fw-semibold">${val('kelompok_padam_event')}</div>
                  </div>
                  <div class="col-md-6 mt-2">
                    <div class="text-muted small">Sub Kelompok Padam Event</div>
                    <div class="fw-semibold">${val('sub_kelompok_padam_event')}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section: Temuan & Justifikasi -->
            <div class="col-12 mb-3">
              <div class="small fw-bold text-uppercase text-secondary mb-2">
                Temuan & Justifikasi
              </div>
              <div class="bg-light rounded-3 p-3">
                <div class="row g-2">
                  <div class="col-12">
                    <div class="text-muted small">Justifikasi / Penyebab</div>
                    <div class="fw-semibold" style="white-space:pre-wrap;">${val('justifikasi')}</div>
                  </div>
                  <div class="col-12 mt-2">
                    <div class="text-muted small">Keterangan</div>
                    <div class="fw-semibold" style="white-space:pre-wrap;">${val('keterangan')}</div>
                  </div>
                  <div class="col-12 mt-2">
                    <div class="text-muted small">Foto Justifikasi</div>
                    <div class="mt-1">${fotoHtml}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section: Petugas -->
            <div class="col-12 mb-3">
              <div class="small fw-bold text-uppercase text-secondary mb-2">
                Petugas
              </div>
              <div class="bg-light rounded-3 p-3">
                <div class="row g-2">
                  <div class="col-md-6">
                    <div class="text-muted small">Petugas Assigned</div>
                    <div class="fw-semibold">${val('nama_petugas_assigned')}</div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-muted small">Piket Petugas / Tim</div>
                    <div class="fw-semibold">${piketNames}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section: Koordinat -->
            <div class="col-12 mb-1">
              <div class="small fw-bold text-uppercase text-secondary mb-2">
                Lokasi & Koordinat
              </div>
              <div class="bg-light rounded-3 p-3">
                <div class="row g-2">
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Latitude</div>
                    <div class="fw-semibold font-monospace small">${val('latitude')}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Longitude</div>
                    <div class="fw-semibold font-monospace small">${val('longitude')}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Tiang Lat</div>
                    <div class="fw-semibold font-monospace small">${val('tiang_latitude')}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="text-muted small">Tiang Lng</div>
                    <div class="fw-semibold font-monospace small">${val('tiang_longitude')}</div>
                  </div>
                </div>
              </div>
            </div>
          `);

          // Render Petugas Tracking Status Section
          const $trackingContainer = $('#detail-petugas-tracking-container');
          $trackingContainer.empty();
          $('#badge-total-petugas-tracking').text(`${trackingList.length} Petugas Terdeteksi`);

          if (!trackingList || trackingList.length === 0) {
            $trackingContainer.html(`
                            <div class="alert alert-light border text-muted small py-2 px-3 mb-0 rounded-3">
                                Belum ada GPS petugas aktif yang terdeteksi pada unit ini.
                            </div>
                        `);
          } else {
            trackingList.forEach((p) => {
              let badgeBg = p.status_badge || 'secondary';
              let statusLabel = p.status_label || 'Standby';
              let distanceText = p.distance_text || '-';
              let speedText = `${p.speed_kmh} km/jam`;
              let timeAgo = p.time_ago || '-';
              let phoneText = p.nomor_hp && p.nomor_hp !== '-' ? ` &bull; HP: ${p.nomor_hp}` : '';

              $trackingContainer.append(`
                                <div class="border rounded-3 p-3 mb-2 bg-light shadow-sm">
                                    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
                                        <div>
                                            <div class="d-flex align-items-center gap-2 mb-1 flex-wrap">
                                                <span class="fw-bold text-dark fs-6">${p.nama_pegawai}</span>
                                                <span class="badge bg-${badgeBg} px-2 py-1">${statusLabel}</span>
                                                ${p.is_jalan ? '<span class="badge bg-primary-subtle text-primary border border-primary-subtle px-2 py-1">Bergerak</span>' : ''}
                                            </div>
                                            <div class="small text-muted">
                                                <span>NIP: ${p.nip}</span>${phoneText} &bull; 
                                                <span>Jarak ke Gangguan: <b>${distanceText}</b></span> &bull; 
                                                <span>Kecepatan: <b>${speedText}</b></span>
                                            </div>
                                        </div>
                                        <div class="text-md-end small text-muted">
                                            <div>Terakhir aktif: <b>${timeAgo}</b></div>
                                            <div class="text-truncate" style="max-width: 220px;" title="${p.device_name || ''}">Perangkat: ${p.device_name || '-'}</div>
                                        </div>
                                    </div>
                                </div>
                            `);
            });
          }

          // Show modal
          $('#modalDetailLogsheet').modal('show');

          // Init or update map
          setTimeout(function () {
            let lat = parseFloat(d.latitude);
            let lng = parseFloat(d.longitude);
            let hasCoords = !isNaN(lat) && !isNaN(lng);

            if (!hasCoords) {
              lat = 0.54848;
              lng = 123.0567;
              $('#detail_koordinat').text('Koordinat gangguan tidak tersedia');
            } else {
              $('#detail_koordinat').html('<b>Lat:</b> ' + lat + ', <b>Lng:</b> ' + lng);
            }

            if (!detailMap) {
              detailMap = L.map('mapDetail').setView([lat, lng], hasCoords ? 14 : 8);
              L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
                maxZoom: 20,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                attribution: '&copy; Google Maps',
              }).addTo(detailMap);
            }

            // Clear previous markers & lines
            if (detailMarker) {
              detailMap.removeLayer(detailMarker);
              detailMarker = null;
            }
            petugasMarkers.forEach((m) => detailMap.removeLayer(m));
            petugasMarkers = [];
            trackingLines.forEach((l) => detailMap.removeLayer(l));
            trackingLines = [];

            // 1. Plot Gangguan Marker
            if (hasCoords) {
              const gangguanIcon = L.divIcon({
                className: 'gangguan-div-icon',
                html: `<div style="background-color: #dc3545; color: white; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(220,53,69,0.6); border: 2px solid white; font-weight: bold; font-size: 13px;">!</div>`,
                iconSize: [32, 32],
                iconAnchor: [16, 16],
                popupAnchor: [0, -16],
              });
              detailMarker = L.marker([lat, lng], { icon: gangguanIcon }).addTo(detailMap);
              detailMarker.bindPopup(`
                                <div style="min-width: 150px;">
                                    <div class="fw-bold text-danger mb-1">Titik Gangguan</div>
                                    <div class="small">${d.indikasi || 'Padam'}</div>
                                    <div class="small text-muted">Penyulang: ${d.nama_penyulang || '-'}</div>
                                </div>
                            `);
            }

            // Helper for Petugas divIcon
            const getPetugasIcon = (statusBadge, isJalan) => {
              let bg = '#0d6efd';
              if (statusBadge === 'success') bg = '#198754';
              else if (statusBadge === 'warning') bg = '#ffc107';
              else if (statusBadge === 'secondary') bg = '#6c757d';

              let textColor = statusBadge === 'warning' ? '#000' : '#fff';
              return L.divIcon({
                className: 'petugas-div-icon',
                html: `<div style="background-color: ${bg}; color: ${textColor}; width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.3); border: 2px solid white; font-size: 11px; font-weight: bold;">P</div>`,
                iconSize: [30, 30],
                iconAnchor: [15, 15],
                popupAnchor: [0, -15],
              });
            };

            // 2. Plot Petugas Markers & Lines
            let boundsPoints = [];
            if (hasCoords) boundsPoints.push([lat, lng]);

            trackingList.forEach((p) => {
              if (p.latitude && p.longitude) {
                let pLat = parseFloat(p.latitude);
                let pLng = parseFloat(p.longitude);
                if (isNaN(pLat) || isNaN(pLng)) return;

                boundsPoints.push([pLat, pLng]);

                let marker = L.marker([pLat, pLng], {
                  icon: getPetugasIcon(p.status_badge, p.is_jalan),
                }).addTo(detailMap);

                marker.bindPopup(`
                                    <div style="min-width: 170px;">
                                        <div class="fw-bold text-dark">${p.nama_pegawai}</div>
                                        <div class="small text-muted mb-1">NIP: ${p.nip}</div>
                                        <div class="mb-1"><span class="badge bg-${p.status_badge}">${p.status_label}</span></div>
                                        <div class="small mb-1">Jarak ke Gangguan: <b>${p.distance_text}</b></div>
                                        <div class="small mb-1">Kecepatan: <b>${p.speed_kmh} km/jam</b></div>
                                        <div class="small text-muted">Update: ${p.time_ago}</div>
                                    </div>
                                `);
                petugasMarkers.push(marker);

                // Connect dashed polyline between officer and disturbance
                if (hasCoords) {
                  let line = L.polyline(
                    [
                      [pLat, pLng],
                      [lat, lng],
                    ],
                    {
                      color: p.is_jalan ? '#0d6efd' : '#6c757d',
                      weight: 3,
                      dashArray: '6, 8',
                      opacity: 0.8,
                    }
                  ).addTo(detailMap);
                  line.bindTooltip(`${p.nama_pegawai} (${p.distance_text})`, { sticky: true });
                  trackingLines.push(line);
                }

                // Plot recent history points if available
                if (p.history && p.history.length > 0) {
                  let trail = L.polyline(p.history, {
                    color: '#198754',
                    weight: 2,
                    opacity: 0.6,
                  }).addTo(detailMap);
                  trackingLines.push(trail);
                }
              }
            });

            // 3. Auto-fit Bounds or Center
            if (boundsPoints.length > 1) {
              detailMap.fitBounds(boundsPoints, { padding: [40, 40], maxZoom: 16 });
            } else if (boundsPoints.length === 1) {
              detailMap.setView(boundsPoints[0], 14);
            } else {
              detailMap.setView([lat, lng], 8);
            }

            detailMap.invalidateSize();
          }, 300);
        } else {
          Swal.fire('Error', res.message || 'Gagal mengambil data', 'error');
        }
      },
      error: function (xhr) {
        Swal.fire('Error', 'Terjadi kesalahan jaringan', 'error');
      },
      complete: function () {
        btn.html(originalHtml).prop('disabled', false);
      },
    });
  });

  $(document).on('click', '.btn-close-logsheet', function (e) {
    e.preventDefault();
    let url = $(this).data('url');

    Swal.fire({
      title: 'Tutup Gangguan Ini?',
      html: `
                <div class="text-start mt-3">
                    <p class="text-muted small mb-3">Pastikan Anda melampirkan justifikasi akhir dan foto penanganan sebelum status diubah menjadi CLOSE.</p>
                    <div class="row">
                        <div class="col-6 mb-3">
                            <label class="form-label small fw-bold text-dark">Latitude (Opsional)</label>
                            <input type="text" id="swal-latitude" class="form-control bg-light" placeholder="0.54848">
                        </div>
                        <div class="col-6 mb-3">
                            <label class="form-label small fw-bold text-dark">Longitude (Opsional)</label>
                            <input type="text" id="swal-longitude" class="form-control bg-light" placeholder="123.0567">
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-dark">Justifikasi / Temuan <span class="text-danger">*</span></label>
                        <textarea id="swal-justifikasi" class="form-control bg-light" rows="3" placeholder="Contoh: Kabel Jumper Putus, sudah disambung kembali..." required></textarea>
                    </div>
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-dark">Foto Penanganan (Opsional)</label>
                        <input type="file" id="swal-foto" class="form-control bg-light" accept="image/*">
                    </div>
                </div>
            `,
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#198754', // Success green
      cancelButtonColor: '#6c757d',
      confirmButtonText: '<i class="bi bi-check-circle me-1"></i> Ya, Tutup Gangguan!',
      cancelButtonText: 'Batal',
      preConfirm: () => {
        const justifikasi = document.getElementById('swal-justifikasi').value;
        const latitude = document.getElementById('swal-latitude').value;
        const longitude = document.getElementById('swal-longitude').value;
        const foto = document.getElementById('swal-foto').files[0];
        if (!justifikasi || justifikasi.trim() === '') {
          Swal.showValidationMessage('Justifikasi wajib diisi!');
          return false;
        }
        return {
          justifikasi: justifikasi.trim(),
          latitude: latitude.trim(),
          longitude: longitude.trim(),
          foto: foto,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const csrfTokenName =
          $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content') || 'csrf_test_name';
        const csrfHash = $('meta[name="X-CSRF-TOKEN"]').attr('content') || '';

        let formData = new FormData();
        if (csrfTokenName && csrfHash) {
          formData.append(csrfTokenName, csrfHash);
        }
        formData.append('justifikasi', result.value.justifikasi);
        if (result.value.latitude) formData.append('latitude', result.value.latitude);
        if (result.value.longitude) formData.append('longitude', result.value.longitude);
        if (result.value.foto) {
          formData.append('foto_justifikasi', result.value.foto);
        }

        $.ajax({
          url: url,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: function (res) {
            if (res.status === 'success') {
              Swal.fire({
                icon: 'success',
                title: 'Ditutup!',
                text: res.message,
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                window.location.reload();
              });
            } else {
              Swal.fire('Gagal', res.message || 'Terjadi kesalahan saat menutup gangguan', 'error');
            }
          },
          error: function (xhr) {
            let msg = xhr.responseJSON ? xhr.responseJSON.message : 'Terjadi kesalahan sistem';
            Swal.fire('Error', msg, 'error');
          },
        });
      }
    });
  });

  // Auto-fill latitude & longitude when a Tiang is chosen
  $(document).on('change', '#id_tiang', function () {
    const $opt = $(this).find(':selected');
    const lat = $opt.attr('data-latitude');
    const lng = $opt.attr('data-longitude');
    if (lat && lng) {
      $('#latitude').val(lat);
      $('#longitude').val(lng);
    }
  });
}
